import axios from 'axios'
import {createSlice, createAsyncThunk, PayloadAction} from '@reduxjs/toolkit'
const api = '/api/'

export const organizationUnitList = createAsyncThunk(
  'organization-unit-list',
  async (params: any, thunkAPI) => {
    try {
      const {data} = await axios.get(`${api}organization-unit/list`, params)
      return data
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data?.errors || 'Something went wrong')
    }
  }
)

export const organizationUnitStore = createAsyncThunk(
  'organization-unit-store',
  async (organizationData: any, thunkAPI) => {
    try {
      const {data} = await axios.post(`${api}organization-unit/store`, organizationData)
      return data
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data || 'Something went wrong')
    }
  }
)

export const organizationUnitMove = createAsyncThunk(
  'organization-unit-move',
  async (organizationData: any, thunkAPI) => {
    try {
      const {data} = await axios.post(`${api}organization-unit/move`, organizationData)
      return data
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data || 'Something went wrong')
    }
  }
)

export const organizationUnitDelete = createAsyncThunk(
  'organization-unit-delete',
  async (id: any, thunkAPI) => {
    try {
      const {data} = await axios.delete(`${api}organization-unit/delete/` + id)
      return data
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data || 'Something went wrong')
    }
  }
)

export const getOrganizationUnits = createAsyncThunk(
  'organization-unit-organizations',
  async (params: any, thunkAPI) => {
    try {
      const {data} = await axios.get(`${api}organization-unit/organizations`, params)
      return data
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data?.errors || 'Something went wrong')
    }
  }
)

export const getOrganizationChilds = createAsyncThunk(
  'organization-unit-childs',
  async (id: string, thunkAPI) => {
    try {
      const {data} = await axios.get(`${api}organization-unit/childs/${id}`)
      return data
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data?.errors || 'Something went wrong')
    }
  }
)

export const getChildsByOraganizationId = createAsyncThunk(
  'organization-unit-childs',
  async (id: string, thunkAPI) => {
    try {
      const {data} = await axios.get(`${api}organization-unit/childs-by-organization/${id}`)
      return data
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data?.errors || 'Something went wrong')
    }
  }
)

export const getOrganizationUnitLists = createAsyncThunk(
  'organization-unit-get',
  async (__, thunkAPI) => {
    try {
      const {data} = await axios.get(`${api}organization-unit/get`)
      return data
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data?.errors || 'Something went wrong')
    }
  }
)

type OrganizationState = {
  errors: any
}

const initialState: OrganizationState = {
  errors: '',
}

export const OrganizationSlice = createSlice({
  name: 'organization',
  initialState,
  reducers: {
    reset: () => initialState,
  },
  extraReducers: (builder) => {
    builder.addCase(organizationUnitMove.rejected, (state, action: PayloadAction<any>) => {
      state.errors = action.payload
    })
  },
})

export const {reset} = OrganizationSlice.actions
export default OrganizationSlice.reducer
